import React from 'react';
import { Button, Input } from '@fragments';
import { IconSearch, IconCheck } from '@tabler/icons-react';
import { categoryLabel } from '../TopicCard';

// Search plus category chips, side by side (stacked on a phone). "Todas" clears the
// categories; any number of them can be on. Locked, both stay visible but disabled.
export default function TrendingToolbar({ studio: s, trending: tr }) {
  const { t } = s;
  const locked = !tr.unlocked;
  const categories = locked ? tr.sampleCategories : tr.tags;
  return <div className="studio-trending__toolbar" role="search">
    <div className="studio-trending__search">
      <Input.Text value={tr.query} onInput={tr.setQuery} placeholder={t('trendingSearch')} aria-label={t('trendingSearch')}
        start={<IconSearch size={16} />} disabled={locked} />
    </div>
    {categories.length > 0 && <div className="studio-trending__chips" role="group" aria-label={t('trendingCategories')}>
      <Button variant="rounded" color={!locked && !tr.categories.length ? 'inverse' : 'overlay'} disabled={locked}
        aria-pressed={!tr.categories.length} onClick={tr.clearCategories}>{t('trendingAll')}</Button>
      {categories.map(tag => {
        const on = tr.categories.includes(tag);
        return <Button key={tag} variant="rounded" color={on ? 'inverse' : 'overlay'} disabled={locked} aria-pressed={on}
          startIcon={on ? <IconCheck /> : null} onClick={() => tr.toggleCategory(tag)}>{categoryLabel(tag)}</Button>;
      })}
    </div>}
  </div>;
}
